import { render, staticRenderFns } from "./BrandCookieModal.vue?vue&type=template&id=5d876f8c&scoped=true&"
import script from "./BrandCookieModal.vue?vue&type=script&lang=js&"
export * from "./BrandCookieModal.vue?vue&type=script&lang=js&"
import style0 from "./BrandCookieModal.vue?vue&type=style&index=0&id=5d876f8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d876f8c",
  null
  
)

export default component.exports